import { softDeleteFlightEvaluation } from '@src/main/modules/reports/flight/application/use-cases/soft-delete-flight-evaluation.usecase';
import { createFlightEvaluationHttpRepository } from '@src/main/modules/reports/flight/infrastructure/repository/FlightEvaluationHttpRepository';
import { useAuth } from '@src/main/shared/context/AuthContext';
import { useMutation } from '@tanstack/react-query';
import { useCallback, useMemo } from 'react';

export const useSoftDeleteFlightEvaluation = () => {
  const { user } = useAuth();

  const getToken = useCallback(async () => user?.token ?? '', [user?.token]);
  const tokenProvider = useMemo(() => ({ getToken }), [getToken]);

  const repository = useMemo(() => {
    if (!user?.token) return null;
    return createFlightEvaluationHttpRepository(tokenProvider);
  }, [user?.token, tokenProvider]);

  return useMutation({
    mutationFn: async (evaluationId: string) => {
      if (!repository) throw new Error('Repository not initialized');
      return await softDeleteFlightEvaluation(repository, evaluationId);
    },
  });
};
